import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJs from 'crypto-js';
import { Variables } from './variable';

const SecureStorage = require('secure-web-storage');
const {
  ACCESS_TOKEN,
  REG_DETAIL,
  USER_DETAIL,
  SIGNIN_CREDENTIALS,
  LOCATION_DETAILS,
  SIDE_BAR,
  OUT_OF_TIME,
  NOTIFICATION,
  COUNTRY,
  OTP_VERIFICATION_ID,
  HELP_CATEGORIES,
  PAYMENT_METHODS,
  FAQS,
} = Variables;

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  secureStorage: any;

  constructor(private router: Router) {
    let SECRET_KEY: any = '%EXP@TSW@P_==_USER_**_APP_%%_HASH_##_HASH%';

    this.secureStorage = new SecureStorage(localStorage, {
      hash: (key: any) => {
        key = CryptoJs.SHA256(key, SECRET_KEY);
        return key.toString();
      },
      encrypt: function encrypt(data: any) {
        data = CryptoJs.AES.encrypt(data, SECRET_KEY);
        data = data.toString();
        return data;
      },
      decrypt: function decrypt(data: any) {
        data = CryptoJs.AES.decrypt(data, SECRET_KEY);
        if (data) {
          try {
            data = data.toString(CryptoJs.enc.Utf8);
            if (data) {
              return data;
            }
          } catch (e) {
            return null;
          }
        }
        return null;
      },
    });

    let data = {
      secret: 'data',
    };

    this.secureStorage.setItem('data', data);
  }

  setAccessToken(token: string): any {
    this.secureStorage.setItem(ACCESS_TOKEN, token);
  }

  getAccessToken(): any {
    let token = this.secureStorage.getItem(ACCESS_TOKEN);
    if (token) {
      return token;
    }
    return null;
  }

  setSideNavState(state: boolean): any {
    this.secureStorage.setItem(SIDE_BAR, state);
  }

  getSideNavState(): any {
    let state = this.secureStorage.getItem(SIDE_BAR);
    if (state) {
      return state;
    }
    return null;
  }

  isAuthenticated(): boolean {
    let token = this.getAccessToken();
    if (token != null) {
      let decodedToken = atob(token.split('.')[1]);
      if (JSON.parse(decodedToken).exp > Date.now() / 1000) return true;
    }
    return false;
  }

  setUserDetails(res: any): any {
    this.secureStorage.setItem(USER_DETAIL, res);
  }

  getUserDetails(): any {
    let res = this.secureStorage.getItem(USER_DETAIL);
    if (res) {
      return res;
    }
    return null;
  }

  setUserRegDetails(res: any): any {
    this.secureStorage.setItem(REG_DETAIL, res);
  }

  getUserRegDetails(): any {
    let res = this.secureStorage.getItem(REG_DETAIL);
    if (res) {
      return res;
    }
    return null;
  }

  getNotifications(): any {
    let res = this.secureStorage.getItem(NOTIFICATION);
    if (res) {
      return res;
    }
    return null;
  }

  setNotifications(res: any): any {
    this.secureStorage.setItem(NOTIFICATION, res);
  }

  clearUserRegDetails(): any {
    this.secureStorage.removeItem(REG_DETAIL);
  }

  clearUserDetails(): any {
    this.secureStorage.removeItem(USER_DETAIL);
  }

  setUserLocationDetails(res: any): any {
    this.secureStorage.setItem(LOCATION_DETAILS, res);
  }

  getUserLocationDetails(): any {
    let res = this.secureStorage.getItem(LOCATION_DETAILS);
    if (res) {
      return res;
    }
    return null;
  }

  removeAccessToken(): any {
    this.secureStorage.removeItem(ACCESS_TOKEN);
  }

  setRememberMeDetails(res: any): any {
    this.secureStorage.setItem(SIGNIN_CREDENTIALS, res);
  }

  getRememberMeDetails(): any {
    let res = this.secureStorage.getItem(SIGNIN_CREDENTIALS);
    if (res) {
      return res;
    }
    return null;
  }

  removeRememberMeDetails(): any {
    this.secureStorage.removeItem(SIGNIN_CREDENTIALS);
  }

  setHelpCategories(res: any): any {
    this.secureStorage.setItem(HELP_CATEGORIES, res);
  }

  getHelpCategories(): any {
    let res = this.secureStorage.getItem(HELP_CATEGORIES);
    if (res) {
      return res;
    }
    return null;
  }

  setPaymentMethods(res: any): any {
    this.secureStorage.setItem(PAYMENT_METHODS, res);
  }

  getPaymentMethods(): any {
    let res = this.secureStorage.getItem(PAYMENT_METHODS);
    if (res) {
      return res;
    }
    return null;
  }

  setFaqs(res: any): any {
    this.secureStorage.setItem(FAQS, res);
  }

  getFaqs(): any {
    let res = this.secureStorage.getItem(FAQS);
    if (res) {
      return res;
    }
    return null;
  }

  setCountries(res: any): any {
    this.secureStorage.setItem(COUNTRY, res);
  }

  getCountries(): any {
    let res = this.secureStorage.getItem(COUNTRY);
    if (res) {
      return res;
    }
    return null;
  }

  setOutOfTime(res: any): any {
    this.secureStorage.setItem(OUT_OF_TIME, res);
  }

  getOutOfTime(): any {
    let res = this.secureStorage.getItem(OUT_OF_TIME);
    if (res) {
      return res;
    }
    return null;
  }

  setOtpVerificationId(res: any): any {
    this.secureStorage.setItem(OTP_VERIFICATION_ID, res);
  }

  getOtpVerificationId(): any {
    let res = this.secureStorage.getItem(OTP_VERIFICATION_ID);
    if (res) {
      return res;
    }
    return null;
  }

  setData(key: string, value: any) {
    let data = JSON.stringify(value);
    localStorage.setItem(key, data);
  }

  getData(key: string) {
    let data = localStorage.getItem(key);
    if (data != null) {
      return JSON.parse(data);
    }
    return null;
  }

  clearAllStorage() {
    this.secureStorage.clear();
  }

  clearAllExceptRememberMe() {
    this.secureStorage.removeItem(ACCESS_TOKEN);
    this.secureStorage.removeItem(REG_DETAIL);
    this.secureStorage.removeItem(USER_DETAIL);
    this.secureStorage.removeItem(SIDE_BAR);
    this.secureStorage.removeItem(OUT_OF_TIME);
    this.secureStorage.removeItem(NOTIFICATION);
    this.secureStorage.removeItem(COUNTRY);
    this.secureStorage.removeItem(OTP_VERIFICATION_ID);
    this.secureStorage.removeItem(HELP_CATEGORIES);
    this.secureStorage.removeItem(PAYMENT_METHODS);
    this.secureStorage.removeItem(FAQS);
  }

  logOutUser() {
    this.clearAllExceptRememberMe();
    this.router.navigateByUrl('auth', { replaceUrl: true });
  }
}
